// External modules
import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';

// Internal modules
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import ACButton from '../../atoms/ACButton';
import PreviewClue from '../../../medias/clue-info-screen.png';

import styles from './SetClue.module.scss';
import { getDefaultClue } from '../../common/clues';
import ACClue from '../../atoms/ACClue';

const clueTypes = [
  { key: 'alphabet-code', value: 'Alphabet Code' },
  { key: 'anagram', value: 'Anagram' },
  { key: 'anagram-meets-trivia', value: 'Anagram Meets Trivia' },
  { key: 'code-craker', value: 'Code Cracker' },
  { key: 'collection-challange', value: 'Collection Challenge' },
  { key: 'crossword', value: 'Crossword' },
  { key: 'hangman', value: 'Hangman' },
  { key: 'identifying-patterns-images', value: 'Identifying Patterns / Images' },
  { key: 'look-for-this-sign-icon', value: 'Look for this Sign / Icon' },
  { key: 'menu-trivia', value: 'Menu Trivia' },
  { key: 'rebus', value: 'Rebus' },
  { key: 'rebus-2', value: 'Rebus 2.0' },
  { key: 'riddle', value: 'Riddle' },
  { key: 'spelling-errors', value: 'Spelling Errors' },
  { key: 'telephone-code', value: 'Telephone Code' },
  { key: 'trivia-word-reveal', value: 'Trivia Word Reveal' },
  { key: 'word-search', value: 'Wordsearch' },
];

export default class SetClue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clue: getDefaultClue(),
      openDialog: false,
    };

    this.onChangeClueText = this.onChangeClueText.bind(this);
    this.onChangeClueDetail = this.onChangeClueDetail.bind(this);
    this.onSaveClue = this.onSaveClue.bind(this);
    this.onUploadClue = this.onUploadClue.bind(this);

    this.onClickDialogClose = this.onClickDialogClose.bind(this);
    this.onClickClearMedia = this.onClickClearMedia.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.clue) {
      this.setState({
        clue: nextProps.clue,
      });
    }
  }

  onClickDialogClose() {
    this.setState({
      openDialog: false,
    });
  }

  onClickClearMedia(type) {
    let { clue } = cloneDeep(this.state);
    clue.details.forEach((detail) => {
      if (detail.type === type) {
        if (detail.medias && detail.medias.length > 0) delete detail['medias'];
      }
    });
    this.setState({
      clue,
    });
  }

  onChangeClueText(key, event) {
    let clue = cloneDeep(this.state.clue);
    const value = event.target.value;

    clue[key] = value;

    this.setState({
      clue,
    });
  }

  onChangeClueDetail(type, key, value) {
    let clue = cloneDeep(this.state.clue);
    clue.details.forEach((detail) => {
      if (detail.type === type) {
        detail[key] = value;
      }
    });
    this.setState({
      clue,
    });
  }

  checkClueValidity = (clueName) => {
    const regex = /^[A-Za-z0-9\s-'+&ÅåÄäÖöÆæØø]+$/;
    const isValid = regex.test(clueName);
    if (!isValid || isEmpty(clueName)) {
      return false;
    } else {
      return true;
    }
  };

  onSaveClue() {
    console.log('onSaveClue')
    let clue = this.state.clue;
    let saveClue = true;

    // AMZG-1967 When showing hints, EEE relies on the Medias having a type, as per Connection Sparks.
    clue.details.forEach((detail) => {
      if (
        detail?.type === 'hard' &&
        detail?.solvable &&
        !this.checkClueValidity(detail?.solvableClue)
      ) {
        saveClue = false;
      }
      if (detail.medias && detail.medias.length) {
        detail.medias.forEach((media) => {
          if (!media.type) {
            media.type = 'image';
          }
        });
      }
    });
    if (saveClue) {
      this.props.onSaveClueFunc(clue);
      if (clue.id) this.props.onCloseFunc();
    }
  }

  onUploadClue(type, files) {
    // Send internal state of the clue to parent for update,
    // otherwise contents such as title, sub-title get overwritten on image upload.

    this.props.onUploadClueFunc(this.props.clue.id, type, files, this.state.clue);
  }

  onClickPreview() {
    this.setState({
      openDialog: true,
    });
  }

  renderMedia(media) {
    if (media) {
      return (
        <img
          alt="media"
          src={media}
          style={{
            maxWidth: 300,
            display: 'flex',
            margin: 'auto',
          }}
        />
      );
    }
  }

  renderDetail(detail) {
    let showTitle = true;
    let showSubtitle = true;
    if (detail.type === 'hint') {
      showTitle = false;
      showSubtitle = false;
    }
    let medias = detail.medias || [];
    let mediaURL = '';
    if (!isEmpty(medias) && medias.length > 0) {
      mediaURL = medias[0].url;
    }
    if (!detail) return <div />;
    const showSolvable = detail.type === 'hard';
    return (
      <div>
        <span className={styles.title}>Clue - {detail.type}</span>
        <div
          style={{
            marginTop: '20px',
            background: 'White',
          }}
        >
          {this.renderMedia(mediaURL)}
          {showTitle && (
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" className={styles.adornment}>
                    Title
                  </InputAdornment>
                ),
              }}
              className={styles.textField}
              value={detail.title}
              onChange={(e) => this.onChangeClueDetail(detail.type, 'title', e.target.value)}
            />
          )}
          {showSubtitle && (
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" className={styles.adornment}>
                    Sub Title
                  </InputAdornment>
                ),
              }}
              className={styles.textField}
              value={detail.subTitle}
              onChange={(e) => this.onChangeClueDetail(detail.type, 'subTitle', e.target.value)}
            />
          )}
          <TextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" className={styles.adornment}>
                  Text
                </InputAdornment>
              ),
            }}
            className={styles.textField}
            value={detail.text}
            onChange={(e) => this.onChangeClueDetail(detail.type, 'text', e.target.value)}
            multiline
            rows="8"
          />
          <div
            style={{
              display: 'flex',
            }}
          >
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" className={styles.adornment}>
                    Media
                  </InputAdornment>
                ),
              }}
              value={mediaURL}
              className={styles.textField}
            />
            <label
              htmlFor={'clear-clue-' + detail.type}
              style={{
                float: 'right',
                background: 'rgb(211, 47, 47)',
                marginTop: 'auto',
                marginRight: '5px',
              }}
            >
              <Button
                component="span"
                style={{
                  color: 'white',
                }}
                onClick={() => this.onClickClearMedia(detail.type)}
              >
                Clear
              </Button>
            </label>
            <input
              id={'upload-clue-' + detail.type}
              type="file"
              style={{ display: 'none' }}
              onChange={(e) => this.onUploadClue(detail.type, e.target.files)}
            />
            <label
              htmlFor={'upload-clue-' + detail.type}
              style={{
                float: 'right',
                background: 'rgb(82, 168, 239)',
                marginTop: 'auto',
              }}
            >
              <Button
                component="span"
                style={{
                  color: 'white',
                }}
              >
                Upload
              </Button>
            </label>
          </div>
        </div>
        {showSolvable && (
          <ACClue
            isChecked={detail?.solvable}
            onCheckChanged={(e) => {
              this.onChangeClueDetail(detail.type, 'solvable', !!e.target.checked);
              if (e.target.checked) {
                setTimeout(() => {
                  this.onChangeClueDetail(
                    detail.type,
                    'solvableClue',
                    detail?.solvableClue ?? this.props.provider?.name
                  );
                }, 700);
              }
            }}
            clueValue={detail?.solvableClue}
            onClueValueChanged={(e) => {
              this.onChangeClueDetail(detail.type, 'solvableClue', e.target.value);
            }}
          />
        )}
      </div>
    );
  }

  renderDetails(details) {
    let detailsComponents = [];

    if (details) {
      details.forEach((detail) => {
        detailsComponents.push(this.renderDetail(detail));
      });
    }

    return detailsComponents;
  }

  renderPreviewExample() {
    return (
      <div>
        <Dialog open={this.state.openDialog} aria-labelledby="draggable-dialog-title">
          <DialogContent>
            <img
              alt="media"
              src={PreviewClue}
              style={{
                display: 'flex',
                margin: 'auto',
                color: 'white',
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.onClickDialogClose}
              color="primary"
              fullWidth="true"
              variant="contained"
              style={{
                color: 'white',
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  renderClueTypes() {
    return clueTypes.map((ct) => {
      return <MenuItem value={ct.key}>{ct.value}</MenuItem>;
    });
  }

  render() {
    const clue = this.state.clue;
    const details = clue.details || [];
    let detailsComponents = <div />;
    if (clue.id) detailsComponents = this.renderDetails(details);
    return (
      <div>
        {this.renderPreviewExample()}
        <Modal open={this.props.isModifying} onClose={this.props.onCloseFunc}>
          <div className={styles.root}>
            <div>
              <div className={styles.fullWidthColumn}>
                <div className={styles.top}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <h3>Set Clue</h3>
                    <div className={styles.previewIcon} onClick={() => this.onClickPreview()}>
                      i
                    </div>
                  </div>
                  <div>
                    <CloseIcon className={styles.pointerCursor} onClick={this.props.onCloseFunc} />
                  </div>
                </div>
                <div className={styles.middle}>
                  <div>
                    <span className={styles.title}>Details</span>
                    <div
                      style={{
                        marginTop: '20px',
                      }}
                    >
                      <TextField
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start" className={styles.adornment}>
                              Name
                            </InputAdornment>
                          ),
                        }}
                        className={styles.textField}
                        value={clue.name}
                        onChange={(e) => this.onChangeClueText('name', e)}
                        placeholder="Clue Name"
                      />
                    </div>
                    <div
                      style={{
                        marginTop: '20px',
                        display: 'flex',
                        flexDirection: 'row',
                      }}
                    >
                      <FormControl className={styles.type}>
                        <span
                          style={{
                            marginLeft: '5px',
                          }}
                        >
                          Type
                        </span>
                        <Select
                          value={clue.type}
                          name="type"
                          onChange={(e) => this.onChangeClueText('type', e)}
                        >
                          <MenuItem value=""></MenuItem>
                          {this.renderClueTypes()}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  {detailsComponents}
                </div>
                <div className={styles.bottom}>
                  <ACButton
                    text={'Save'}
                    icon={<SaveIcon />}
                    iconLast={true}
                    onClickFunc={this.onSaveClue}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
